import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockDef } from '../../defs/map';
import {
  _spawnBaseBlockEntity,
  setBlockEntityViewLayer,
} from '../../entities/BlockEntity';
import { MagicBunniesBlockComponent } from './MagicBunniesBlockComponent';
import { MagicBunniesBlockProps } from './MagicBunniesBlock';

const MagicBunniesBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  MagicBunniesBlockComponent,
);
export type MagicBunniesBlockEntity = EntityType<
  typeof MagicBunniesBlockEntityDef
>;

export function _spawnMagicBunniesBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: MagicBunniesBlockProps,
  position: Vector2,
): MagicBunniesBlockEntity {
  const entity = _spawnBaseBlockEntity(
    MagicBunniesBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockMagicBunnies: {
        props: props,
        option: def.option,
      },
    },
  );
  entity.c.view2d.view.addChild(entity.c.blockMagicBunnies.view);
  return entity;
}
